import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-requests-procedures-alert',
  templateUrl: './requests-procedures-alert.component.html',
  styleUrls: ['./requests-procedures-alert.component.scss']
})
export class RequestsProceduresAlertComponent implements OnInit {
  @Input() data: object;
  Form: FormGroup;
  status: boolean;
  states: any[];

  constructor(private fb: FormBuilder, private activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.Form = this.fb.group({
      id: [this.data['request']['id'] || '', Validators.required],
      comment: [this.data['request']['message'] || '', Validators.required],
      statusId: [this.data['request']['status'] || '', Validators.required],
      codeId: [1, Validators.required],
      processFinalize: [false],
      successFinalize: [false],
      isRequest: [this.data['isRequest']],
      days: [0],
      json: [this.data['request']['json'] || '', Validators.required],
      document: [this.data['request']['document']]
    });
    this.states = this.data['states'];
  }

  emit(): void {
    if (this.Form.valid) {
      const form = { ...this.Form.value };
      form.processFinalize = this.states.filter((s) => s.id === form.statusId)[0].finalize;
      form.successFinalize = this.states.filter((s) => s.id === form.statusId)[0].success;

      this.activeModal.close(form);
    }
  }
}
